import { Component, OnInit, ViewChild } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from 'src/@shared/custom.validator';
import { ClrForm } from '@clr/angular';
import { LoginService } from 'src/@core/http/login';
import { LoginResponseModel, LoginRequestModel, Role, LocalStorageKey } from 'src/@core/http/login/login.model';
import { UserInfoModel } from "src/@core/http/login/UserInfoModel";
import { Router, ActivatedRoute } from '@angular/router';
import { RoleService, SignalRService} from 'src/@core/http';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss'],
})

export class LoginComponent implements OnInit {
    public loginForm: FormGroup;
    private redirectUrl: string;
    @ViewChild(ClrForm) clrForm;
    constructor(private formBuilder: FormBuilder,
        private service: LoginService,
      private router: Router,
      private signalRservice:SignalRService,
        private activatedRoute: ActivatedRoute,
      private roleService: RoleService,
        private toastrService: ToastrService) {
        this.activatedRoute.queryParams.subscribe(params => {
            this.redirectUrl = this.trimEnd(params['returnUrl'], '/');
        });
    }

    ngOnInit() {
        this.buildForm();
    }

    private buildForm() {
        this.loginForm = this.formBuilder.group({
            Email: ['', [Validators.required, Validators.email]],
            Password: ['', [CustomValidator.required('password')]]
        });
    }

    public loginBtnClick() {
        if (this.loginForm.invalid) {
            this.emailCtrl.markAsTouched();
            this.passwordCtrl.markAsTouched();
            this.clrForm.markAsDirty();
        } else {
            const model: LoginRequestModel = this.loginForm.getRawValue();
            this.service.login(model).subscribe((result: LoginResponseModel) => {
                // store localstorage
                result.user.roles = result.roles;
                localStorage.setItem(LocalStorageKey.Token, result.accessToken);
                localStorage.setItem(LocalStorageKey.CurrentUser, JSON.stringify(result.user));
                this.redirectToPage(result.user);
            }, (err: any) => {
                this.toastrService.error('Wrong username or password. Try again or click Forgot password to reset it', 'Login', {
                    timeOut: 3000,
                    toastClass: 'toast toast-default-font'
                });
                console.log(err);
            });
        }
    }

    public get emailCtrl() {
        return this.loginForm.get('Email');
    }

    public get passwordCtrl() {
        return this.loginForm.get('Password');
    }

    private redirectToPage(user: UserInfoModel) {
        if (user && user.roles) {
          const isAdmin = user.roles.find(r => r === Role.Admin);
     
            if (isAdmin) {
                // redirect to admin portal
              const redirect = this.redirectUrl ? this.redirectUrl : '/admin/consignments/consignment-dashboard';
              this.signalRservice.myUser = user;
              this.signalRservice.setQuoteBranch(user.branchFlag)

              //const redirect = this.redirectUrl ? this.redirectUrl : 'admin';
              this.router.navigateByUrl(redirect);
            } else {
                if (user.isFirstLogin) {
                    // redirect to T&C
                    this.router.navigateByUrl('login/terms');
                    return;
                }
                const redirect = this.redirectUrl ? this.redirectUrl : 'customer';
                this.router.navigateByUrl(redirect);
            }
        }
    }

    private trimEnd(text: string, char: string): string {
        if (text && char) {
            while (text.endsWith(char)) {
                text = text.substring(0, text.length - char.length);
            }
        }
        return text;
    }
}
